// Standort-Datenbank für SEO-optimierte Geo-Landingpages
// Jede Stadt bekommt eine eigene URL: /standort/<slug>
// Alle 15 Standorte im 25km-Umkreis um Krefeld

export const locations = [
  {
    slug: "krefeld",
    name: "Krefeld",
    name_genitiv: "Krefelds",
    name_dativ: "Krefeld",
    plz_list: ["47798", "47799", "47800", "47802", "47803", "47804", "47805", "47806", "47807", "47809", "47829", "47839"],
    distance_km: 0,
    drive_min: 0,
    lat: 51.3388,
    lng: 6.5853,
    bundesland: "Nordrhein-Westfalen",
    stadtteile: ["Uerdingen", "Fischeln", "Hüls", "Oppum", "Linn", "Bockum", "Verberg", "Stadtmitte", "Benrad", "Inrath", "Traar", "Gartenstadt"],
    nachbarorte: ["Meerbusch", "Willich", "Tönisvorst", "Duisburg", "Moers"],
    local_fact: "Krefeld – die Samt- und Seidenstadt am Rhein. Hier bin ich zuhause und hier kenne ich jeden Winkel.",
    hero_intro: "Als Krefelderin bin ich direkt vor Ort – schneller geht's nicht. Persönliche Beratung, Erlebniskochen und unverbindliche Vorführung direkt bei dir in Krefeld.",
    why_me: "Ich wohne selbst in Krefeld und kenne die Stadt wie meine Westentasche. Ob Uerdingen, Hüls, Fischeln oder Bockum – ich bin in wenigen Minuten bei dir. Als deine feste Ansprechpartnerin bleibe ich dir auch nach dem Kauf als zuverlässige Unterstützung erhalten.",
    highlights: [
      "Schnellster Vor-Ort-Termin in ganz Krefeld (oft noch am selben Tag)",
      "Persönlicher Service direkt in deinem Stadtteil",
      "Exklusive Krefelder Kunden-WhatsApp-Gruppe"
    ]
  },
  {
    slug: "meerbusch",
    name: "Meerbusch",
    name_genitiv: "Meerbuschs",
    name_dativ: "Meerbusch",
    plz_list: ["40667", "40668", "40670"],
    distance_km: 8,
    drive_min: 12,
    lat: 51.2514,
    lng: 6.6814,
    bundesland: "Nordrhein-Westfalen",
    stadtteile: ["Büderich", "Osterath", "Lank-Latum", "Strümp", "Bösinghoven", "Langst-Kierst", "Ossum-Bösinghoven", "Nierst"],
    nachbarorte: ["Krefeld", "Düsseldorf", "Neuss", "Kaarst"],
    local_fact: "Meerbusch – die grüne Lunge zwischen Düsseldorf und Krefeld mit ihren charmanten Ortsteilen und dem Rheinufer.",
    hero_intro: "Von Büderich über Osterath bis Lank-Latum: Ich komme zu dir nach Meerbusch und bringe dein Thermomix-Erlebnis direkt in deine Küche.",
    why_me: "Meerbusch liegt für mich quasi um die Ecke – in nur 12 Minuten bin ich bei dir. Ich kenne die Besonderheiten der verschiedenen Ortsteile und nehme mir Zeit für eine entspannte Vorführung, genauso wie es zum gehobenen Lebensgefühl in Meerbusch passt.",
    highlights: [
      "Vorführung in allen Meerbuscher Ortsteilen",
      "Exklusiver Service für anspruchsvolle Kundinnen & Kunden",
      "Persönliche Rezept-Empfehlungen aus der Region"
    ]
  },
  {
    slug: "willich",
    name: "Willich",
    name_genitiv: "Willichs",
    name_dativ: "Willich",
    plz_list: ["47877", "47918"],
    distance_km: 10,
    drive_min: 15,
    lat: 51.2633,
    lng: 6.5508,
    bundesland: "Nordrhein-Westfalen",
    stadtteile: ["Alt-Willich", "Anrath", "Neersen", "Schiefbahn"],
    nachbarorte: ["Krefeld", "Tönisvorst", "Viersen", "Mönchengladbach"],
    local_fact: "Willich – viergeteilt und lebendig, von Anrath bis Neersen eine Gemeinde mit Charakter.",
    hero_intro: "Ob in Alt-Willich, Anrath, Neersen oder Schiefbahn – dein Thermomix-Termin in Willich ist bei mir in besten Händen.",
    why_me: "Als Nachbarin aus Krefeld bin ich schnell in Willich. Für Familien und Berufstätige biete ich auch Abend- und Wochenendtermine, damit alle dabei sein können.",
    highlights: [
      "Alle vier Ortsteile (Anrath, Schiefbahn, Neersen, Alt-Willich)",
      "Flexible Terminzeiten – auch abends",
      "Kostenlose Lieferung nach Willich inklusive"
    ]
  },
  {
    slug: "toenisvorst",
    name: "Tönisvorst",
    name_genitiv: "Tönisvorsts",
    name_dativ: "Tönisvorst",
    plz_list: ["47918"],
    distance_km: 8,
    drive_min: 13,
    lat: 51.3197,
    lng: 6.4856,
    bundesland: "Nordrhein-Westfalen",
    stadtteile: ["St. Tönis", "Vorst"],
    nachbarorte: ["Krefeld", "Kempen", "Willich"],
    local_fact: "Tönisvorst – die Apfelstadt am Niederrhein, bekannt für ihre Obstwiesen.",
    hero_intro: "Apfelkuchen, Marmeladen, Säfte – im Thermomix zauberst du daraus alles ganz einfach. Ich zeige es dir bei dir zuhause in Tönisvorst.",
    why_me: "Als Nachbarin aus Krefeld bin ich im Handumdrehen in St. Tönis oder Vorst. Perfekt auch für alle, die die regionalen Produkte vom Niederrhein wertschätzen und zuhause frisch verarbeiten wollen.",
    highlights: [
      "Vorführung in St. Tönis und Vorst",
      "Rezept-Tipps für regionale Niederrhein-Produkte",
      "Schnelle Anfahrt – oft in unter 15 Minuten"
    ]
  },
  {
    slug: "kempen",
    name: "Kempen",
    name_genitiv: "Kempens",
    name_dativ: "Kempen",
    plz_list: ["47906"],
    distance_km: 13,
    drive_min: 18,
    lat: 51.3639,
    lng: 6.4181,
    bundesland: "Nordrhein-Westfalen",
    stadtteile: ["Alt-Kempen", "St. Hubert", "Tönisberg", "Schmalbroich"],
    nachbarorte: ["Tönisvorst", "Krefeld", "Grefrath", "Nettetal"],
    local_fact: "Kempen – charmante Altstadt, Burg und Kuhtor: hier lebt Geschichte.",
    hero_intro: "Historische Altstadt trifft moderne Küche: Dein TM7-Erlebnis in Kempen – persönlich und mit Herz.",
    why_me: "Kempen ist einer meiner liebsten Termine – die Atmosphäre in der Altstadt ist einzigartig. Ich bin auch für St. Hubert und Tönisberg zuständig und nehme mir für jede Vorführung genug Zeit.",
    highlights: [
      "Alt-Kempen, St. Hubert, Tönisberg & Schmalbroich",
      "Flexible Termine auch am Wochenende",
      "Persönliche Betreuung – keine anonyme Beratung"
    ]
  },
  {
    slug: "viersen",
    name: "Viersen",
    name_genitiv: "Viersens",
    name_dativ: "Viersen",
    plz_list: ["41747", "41748", "41749", "41751"],
    distance_km: 17,
    drive_min: 22,
    lat: 51.2543,
    lng: 6.3942,
    bundesland: "Nordrhein-Westfalen",
    stadtteile: ["Alt-Viersen", "Dülken", "Süchteln", "Boisheim", "Hoser", "Rahser"],
    nachbarorte: ["Willich", "Mönchengladbach", "Grefrath", "Nettetal"],
    local_fact: "Viersen – grüne Stadt am Niederrhein mit lebendigen Ortsteilen Dülken und Süchteln.",
    hero_intro: "Von Alt-Viersen über Dülken bis Süchteln: Dein Thermomix-Termin in Viersen mit persönlicher Note.",
    why_me: "Auch wenn Viersen etwas weiter weg ist – die Fahrt lohnt sich für uns beide. Ich nehme mir Zeit und plane so, dass wir entspannt kochen, plaudern und das Gerät ausgiebig testen können.",
    highlights: [
      "Alt-Viersen, Dülken, Süchteln & Boisheim",
      "Erlebniskochen für Familien & Freunde",
      "Ausführliche Beratung ohne Zeitdruck"
    ]
  },
  {
    slug: "moers",
    name: "Moers",
    name_genitiv: "Moers'",
    name_dativ: "Moers",
    plz_list: ["47441", "47443", "47445", "47447"],
    distance_km: 15,
    drive_min: 20,
    lat: 51.4532,
    lng: 6.6232,
    bundesland: "Nordrhein-Westfalen",
    stadtteile: ["Alt-Moers", "Repelen", "Rheinkamp", "Kapellen", "Hochstraß", "Scherpenberg", "Schwafheim", "Utfort"],
    nachbarorte: ["Krefeld", "Duisburg", "Neukirchen-Vluyn"],
    local_fact: "Moers – Schloss, Park und das berühmte Moers Festival: die Perle im Kreis Wesel.",
    hero_intro: "Auf der linken Rheinseite: Ich komme auch nach Moers und in alle Stadtteile – von Repelen bis Kapellen.",
    why_me: "Moers ist ein fester Bestandteil meines Gebiets. Egal ob du in der Altstadt, in Repelen oder Rheinkamp wohnst – ich bringe dir den Thermomix direkt an die Haustür.",
    highlights: [
      "Alle Moerser Stadtteile – auch am Rand",
      "Vorführung mit saisonalen Niederrhein-Rezepten",
      "Familien-freundliche Terminzeiten"
    ]
  },
  {
    slug: "neuss",
    name: "Neuss",
    name_genitiv: "Neuss'",
    name_dativ: "Neuss",
    plz_list: ["41460", "41462", "41464", "41466", "41468", "41469", "41470", "41472"],
    distance_km: 18,
    drive_min: 25,
    lat: 51.1981,
    lng: 6.6916,
    bundesland: "Nordrhein-Westfalen",
    stadtteile: ["Innenstadt", "Weckhoven", "Erfttal", "Derikum", "Grefrath", "Holzheim", "Grimlinghausen", "Uedesheim", "Norf", "Rosellen", "Hoisten", "Reuschenberg", "Furth"],
    nachbarorte: ["Düsseldorf", "Meerbusch", "Kaarst", "Korschenbroich"],
    local_fact: "Neuss – zweitälteste Stadt Deutschlands mit Hafen, Quirinus-Münster und Schützenfest-Tradition.",
    hero_intro: "Neuss und Umgebung: Ich bringe den Thermomix® TM7 zu dir – ob in der Innenstadt, in Furth oder Norf.",
    why_me: "Auch die Neusser bekommen bei mir die volle Aufmerksamkeit. Ich plane meine Touren so, dass ich mich komplett auf dich konzentrieren kann. Persönlich, ruhig und ohne Verkaufsdruck.",
    highlights: [
      "Alle Neusser Stadtteile inkl. Norf, Furth, Grimlinghausen",
      "Beratung auch auf Wunsch in kleinen Gruppen",
      "Zeit für alle Fragen – ohne Druck"
    ]
  },
  {
    slug: "kaarst",
    name: "Kaarst",
    name_genitiv: "Kaarsts",
    name_dativ: "Kaarst",
    plz_list: ["41564"],
    distance_km: 16,
    drive_min: 22,
    lat: 51.2308,
    lng: 6.6197,
    bundesland: "Nordrhein-Westfalen",
    stadtteile: ["Alt-Kaarst", "Büttgen", "Holzbüttgen", "Driesch", "Vorst"],
    nachbarorte: ["Neuss", "Korschenbroich", "Meerbusch"],
    local_fact: "Kaarst – jung, grün und familienfreundlich zwischen Neuss und Mönchengladbach.",
    hero_intro: "Ob in Alt-Kaarst, Büttgen oder Holzbüttgen – dein Thermomix-Termin in Kaarst mit persönlichem Service.",
    why_me: "Kaarst gehört zu meinem festen Einzugsgebiet. Gerade junge Familien schätzen es, wenn die Vorführung abends oder am Wochenende in der eigenen Küche stattfinden kann.",
    highlights: [
      "Alle fünf Kaarster Ortsteile",
      "Ideal für junge Familien",
      "Flexible Termine nach Feierabend"
    ]
  },
  {
    slug: "grefrath",
    name: "Grefrath",
    name_genitiv: "Grefraths",
    name_dativ: "Grefrath",
    plz_list: ["47929"],
    distance_km: 15,
    drive_min: 20,
    lat: 51.3361,
    lng: 6.3436,
    bundesland: "Nordrhein-Westfalen",
    stadtteile: ["Grefrath", "Oedt", "Vinkrath", "Mülhausen"],
    nachbarorte: ["Kempen", "Nettetal", "Viersen"],
    local_fact: "Grefrath – Eissport-Hochburg und idyllischer Ort im Kreis Viersen.",
    hero_intro: "Dein Thermomix in Grefrath, Oedt, Vinkrath oder Mülhausen – persönlich präsentiert von Jennifer Laak.",
    why_me: "Grefrath und seine Ortsteile fahre ich gerne an. Die ländliche Ruhe passt perfekt zu einer entspannten, ausführlichen Vorführung – ideal für alle, die sich Zeit nehmen wollen.",
    highlights: [
      "Alle Grefrather Ortsteile inkl. Oedt & Mülhausen",
      "Entspannte Vorführung ohne Hektik",
      "Rezepte für niederrheinische Küche"
    ]
  },
  {
    slug: "nettetal",
    name: "Nettetal",
    name_genitiv: "Nettetals",
    name_dativ: "Nettetal",
    plz_list: ["41334"],
    distance_km: 20,
    drive_min: 25,
    lat: 51.3233,
    lng: 6.2708,
    bundesland: "Nordrhein-Westfalen",
    stadtteile: ["Lobberich", "Kaldenkirchen", "Breyell", "Hinsbeck", "Leuth", "Schaag"],
    nachbarorte: ["Grefrath", "Viersen", "Brüggen"],
    local_fact: "Nettetal – Stadt der Seen mit einzigartiger Naturlandschaft.",
    hero_intro: "Ob in Lobberich, Kaldenkirchen oder Hinsbeck – auch in Nettetal bringe ich dir den Thermomix® TM7 direkt nach Hause.",
    why_me: "Nettetal ist Naturidylle pur – und in so einer Umgebung macht Kochen doppelt Freude. Ich komme gerne bis an die holländische Grenze, um dir den Thermomix live zu zeigen.",
    highlights: [
      "Alle sechs Nettetaler Stadtteile",
      "Vorführung bis nach Kaldenkirchen",
      "Regionale Rezepte mit frischen Zutaten"
    ]
  },
  {
    slug: "korschenbroich",
    name: "Korschenbroich",
    name_genitiv: "Korschenbroichs",
    name_dativ: "Korschenbroich",
    plz_list: ["41352"],
    distance_km: 20,
    drive_min: 25,
    lat: 51.1903,
    lng: 6.5158,
    bundesland: "Nordrhein-Westfalen",
    stadtteile: ["Korschenbroich", "Kleinenbroich", "Glehn", "Pesch", "Liedberg"],
    nachbarorte: ["Kaarst", "Neuss", "Mönchengladbach"],
    local_fact: "Korschenbroich – kleine, feine Stadt mit viel Grün und historischem Charme.",
    hero_intro: "Von Korschenbroich über Kleinenbroich bis Glehn: Ich komme zu dir für deine Thermomix-Vorführung.",
    why_me: "Korschenbroich hat einen besonderen Charme – ruhig, grün und familiär. Das passt perfekt zu meinem Stil: entspannte Beratung ohne Hektik.",
    highlights: [
      "Alle fünf Korschenbroicher Ortsteile",
      "Entspannte Atmosphäre",
      "Persönlich statt Massenabfertigung"
    ]
  },
  {
    slug: "moenchengladbach",
    name: "Mönchengladbach",
    name_genitiv: "Mönchengladbachs",
    name_dativ: "Mönchengladbach",
    plz_list: ["41061", "41063", "41065", "41066", "41068", "41069", "41169", "41179", "41189", "41199", "41236", "41238", "41239"],
    distance_km: 25,
    drive_min: 30,
    lat: 51.1805,
    lng: 6.4428,
    bundesland: "Nordrhein-Westfalen",
    stadtteile: ["Gladbach", "Rheydt", "Odenkirchen", "Giesenkirchen", "Hardt", "Volksgarten", "Windberg", "Wickrath"],
    nachbarorte: ["Viersen", "Korschenbroich", "Willich"],
    local_fact: "Mönchengladbach – die Stadt von Borussia, textiler Tradition und vielfältigen Vierteln.",
    hero_intro: "In Gladbach, Rheydt oder Wickrath: Ich bringe dir den Thermomix® TM7 – persönlich und mit Leidenschaft.",
    why_me: "Mönchengladbach gehört noch ins 25km-Gebiet und ich komme gerne. Besonders die Stadtteile Richtung Krefeld (Hardt, Neuwerk) sind schnell erreichbar – aber auch nach Rheydt oder Odenkirchen mache ich gerne den Weg.",
    highlights: [
      "Alle Stadtteile Mönchengladbachs bedienbar",
      "Vor allem schneller Service in Nord-MG",
      "Persönliche Rezepte und Tipps"
    ]
  },
  {
    slug: "duisburg",
    name: "Duisburg",
    name_genitiv: "Duisburgs",
    name_dativ: "Duisburg",
    plz_list: ["47057", "47058", "47059", "47119", "47137", "47138", "47139", "47166", "47167", "47169", "47178", "47179", "47198", "47199", "47226", "47228", "47229", "47239", "47249", "47259", "47269", "47279"],
    distance_km: 20,
    drive_min: 25,
    lat: 51.4344,
    lng: 6.7623,
    bundesland: "Nordrhein-Westfalen",
    stadtteile: ["Rheinhausen", "Homberg", "Rumeln-Kaldenhausen", "Baerl", "Hochheide", "Friemersheim"],
    nachbarorte: ["Krefeld", "Moers", "Mülheim"],
    local_fact: "Duisburg – Hafenstadt am Rhein, Ruhrgebiet mit Herz und vielseitigen Stadtteilen.",
    hero_intro: "Vor allem Duisburg-West: Rheinhausen, Homberg, Rumeln-Kaldenhausen und Baerl – ich bin für dich da.",
    why_me: "Mein Hauptgebiet in Duisburg ist der Westen – linksrheinisch und damit schnell von Krefeld aus erreichbar. Für Homberg, Rheinhausen & Co bin ich deine Ansprechpartnerin.",
    highlights: [
      "Fokus Duisburg-West (linksrheinisch)",
      "Rheinhausen, Homberg, Rumeln, Baerl",
      "Kurze Anfahrt – schneller Termin möglich"
    ]
  },
  {
    slug: "duesseldorf",
    name: "Düsseldorf",
    name_genitiv: "Düsseldorfs",
    name_dativ: "Düsseldorf",
    plz_list: ["40210", "40211", "40212", "40213", "40215", "40217", "40219", "40221", "40223", "40225", "40227", "40229", "40231", "40233", "40235", "40237", "40239", "40468", "40470", "40472", "40474", "40476", "40477", "40479", "40489", "40545", "40547", "40549", "40589", "40591", "40593", "40595", "40597", "40599", "40625", "40627", "40629"],
    distance_km: 25,
    drive_min: 30,
    lat: 51.2277,
    lng: 6.7735,
    bundesland: "Nordrhein-Westfalen",
    stadtteile: ["Kaiserswerth", "Lohausen", "Stockum", "Unterrath", "Lörick", "Heerdt", "Oberkassel", "Niederkassel"],
    nachbarorte: ["Meerbusch", "Neuss", "Ratingen"],
    local_fact: "Düsseldorf – Mode-, Kunst- und Rheinmetropole mit Königsallee und Altstadt.",
    hero_intro: "Vor allem Düsseldorf-Nord & linksrheinisch: Kaiserswerth, Lohausen, Heerdt, Oberkassel – ich komme zu dir.",
    why_me: "Mein Aktionsradius erreicht auch Düsseldorf – schwerpunktmäßig die nördlichen und linksrheinischen Stadtteile. Für diese Gebiete bin ich schnell da und biete dir die komplette persönliche Beratung in deinem Zuhause.",
    highlights: [
      "Schwerpunkt Düsseldorf-Nord & linksrheinisch",
      "Kaiserswerth, Lohausen, Heerdt, Oberkassel",
      "Edle Vorführung für den gehobenen Anspruch"
    ]
  }
];

export const getLocationBySlug = (slug) => locations.find((l) => l.slug === slug);
